export enum ResearchRatingBlock {
  Root = 'ResearchRating',
}
